var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "bj-contact" },
    _vm._l(_vm.contactData, function (item, index) {
      return _c(
        "li",
        {
          key: index,
          staticClass: "box",
          on: {
            mouseover: function ($event) {
              return _vm.mouseOver(item)
            },
            mouseleave: function ($event) {
              return _vm.mouseLeave(item)
            },
          },
        },
        [
          _c("BjKeyImage", {
            staticStyle: { width: "24px" },
            attrs: { url: item.url },
          }),
          _c("p", [_vm._v(_vm._s(item.text))]),
          index === 0
            ? _c("BjKeyImage", {
                staticClass: "content wx",
                attrs: { url: _vm.$getPublicImage("wx.png") },
              })
            : _vm._e(),
          index === 1
            ? _c("div", { staticClass: "content phone" }, [
                _vm._v("139 39145 487"),
              ])
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }